/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import moment from "moment";


export class OwnershipConfirmationController {

    static $inject = ["$scope",
        "$state",
        "$http",
        "$filter",
        "CacheService",
        "$uibModalInstance",
        "ApiAdapterService",
        "PopUpService",
        "request",
        "popupType"
    ];

    constructor($scope,
        $state,
        $http,
        $filter,
        CacheService,
        $uibModalInstance,
        ApiAdapterService,
        PopUpService,
        request,
        popupType
    ) {
        var ownershipConfirmationVm: any = this;
        ownershipConfirmationVm.request = {};
        ownershipConfirmationVm.popupType = {};
        ownershipConfirmationVm.daysAgo = null;

        ownershipConfirmationVm.init = () => {
            ownershipConfirmationVm.request = request;
            ownershipConfirmationVm.popupType = popupType;
            ownershipConfirmationVm.daysAgo = moment(new Date(request.invitedDate)).fromNow();
            console.log(ownershipConfirmationVm.daysAgo);
        }

        ownershipConfirmationVm.closePopup = () => {
            $uibModalInstance.dismiss();
        }

        //user clicks on keep me in the team button
        ownershipConfirmationVm.keepMeInTheTeam = () => {
            $uibModalInstance.dismiss();
        }

        // remove user from team
        ownershipConfirmationVm.removeMeFromTheTeam = () => {
            var subjType = "the " + ownershipConfirmationVm.request.projectName + " Project";
            if (ownershipConfirmationVm.request.subjectTypeId == "INDIVIDUAL") {
                subjType = ownershipConfirmationVm.request.subjectName + "'s";
            }
            ApiAdapterService.exitTeam(ownershipConfirmationVm.request.subjectId, ownershipConfirmationVm.request.ownerId).then((s) => {
                PopUpService.openInformationModal("You have been removed from " + subjType + " Team.").then((s) => {
                    $state.reload();
                });
            }, (e) => {
                PopUpService.openInformationModal("Unable to remove you from " + subjType + " Team.");
            });
            $uibModalInstance.dismiss();
        }

        //cancel team ownership request and initiate new transfer request
        ownershipConfirmationVm.cancelAndTransferToAnother = (msg) => {
            ownershipConfirmationVm.loader = "Cancelling request...";
            ApiAdapterService.updateOwnershipRecord(ownershipConfirmationVm.request, true).then(
                (s) => {
                    ownershipConfirmationVm.transferToAnotherTeamMember(msg);
                },
                (e) => {
                    $uibModalInstance.dismiss();
                }
            );

        }

        //just cancel the current request dont initiate new request
        ownershipConfirmationVm.cancelRequest = (msg) => {
            ownershipConfirmationVm.loader = true;
            ApiAdapterService.updateOwnershipRecord(ownershipConfirmationVm.request, true).then(
                (s) => {
                    if (msg != null) {
                        PopUpService.openInformationModal(msg);
                    }
                    $uibModalInstance.dismiss();
                },
                (e) => {
                    $uibModalInstance.dismiss();
                }
            );
        }

        ownershipConfirmationVm.transferToAnotherTeamMember = (msg) => {
            ownershipConfirmationVm.loader = "Please wait...";
            // get subject details to re initialize transfer request
            var subject = null;
            var owner = CacheService.getUser();
            var title = (msg != null ? msg : "If you transfer the Team Captain badge to another Team Member, the previous request to " +
                ownershipConfirmationVm.request.invitedMemberName + " will be cancelled. " +
                "Would you like to transfer the badge to another Team Member?");


            ApiAdapterService.getSubject(ownershipConfirmationVm.request.subjectId, CacheService.getPassword()).then(
                (s) => {
                    subject = s;
                    ApiAdapterService.getTeamMembers(ownershipConfirmationVm.request.subjectId).then(
                        (s) => {
                            subject.teamMembers = s;
                            ownershipConfirmationVm.loader = false;
                            $uibModalInstance.dismiss();
                            PopUpService.OpenTransferOwnershipModal(owner, subject, false, ownershipConfirmationVm.request, false, true, title).then(s => {
                                if (s) {
                                    ownershipConfirmationVm.updateRequestStatus(ownershipConfirmationVm.request);
                                    $uibModalInstance.dismiss();
                                }
                            }, (e) => {
                                console.log(e);
                            });
                        },
                        (e) => {

                        }
                    )
                },
                (e) => {

                }
            )
        }

        // sent reminder
        ownershipConfirmationVm.sendReminder = () => {
            ApiAdapterService.processReminderRequestForOwnership(request);
            $uibModalInstance.dismiss();
        }

        //accept ownership accepted
        ownershipConfirmationVm.acceptOwnership = () => {
            ownershipConfirmationVm.loader = "Transferring Team Captain badge...";
            ownershipConfirmationVm.processOwnershipRequest(ownershipConfirmationVm.request, true);
        }

        //reject ownership request
        ownershipConfirmationVm.rejectOwnership = () => {
            ownershipConfirmationVm.loader = "Declining Team Captain badge request...";
            ownershipConfirmationVm.processOwnershipRequest(ownershipConfirmationVm.request, false);
        }

        //process ownership request
        ownershipConfirmationVm.processOwnershipRequest = (request, accepted) => {
            ApiAdapterService.processTransferOwnershipRequest(request, accepted).then(
                (s) => {
                    ownershipConfirmationVm.loader = false;
                    $uibModalInstance.close(accepted);

                    if (accepted) {
                        let msg = "Team Captain badge accepted for ";
                        if (request.subjectTypeId == 'INDIVIDUAL') {
                            msg += request.subjectName + "'s Team successfully."
                        } else if (request.subjectTypeId == 'PROJECT') {
                            msg += "the " + request.projectName + " Project Team successfully."
                        }
                        toastr.success(msg);
                    }
                    if (!accepted) {
                        toastr.success("Team Captain badge request declined.");
                    }
                },
                (e) => {
                    ownershipConfirmationVm.loader = false;
                }
            );
        }

        ownershipConfirmationVm.updateRequestStatus = (requestObj) => {
            ApiAdapterService.updateOwnershipRecord(requestObj, true);
        }

        ownershipConfirmationVm.init();
    }
}


angular.module('eCareVault.common.popUp')
    .controller('OwnershipConfirmationController', OwnershipConfirmationController);
